import { render, staticRenderFns } from "./Transactions.view.vue?vue&type=template&id=c634763a"
import script from "./Transactions.view.vue?vue&type=script&lang=ts"
export * from "./Transactions.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports